const startYear = 2026;
const year = new Date().getFullYear();
const yearSpan = startYear === year? year: `${startYear}-${year}`;
const about = {
  name: 'LINKPlanner',
  email: 'linkplanner@airspan.com',
  copyright: `\u00A9 ${yearSpan} Airspan Networks Holdings LLC. All rights reserved`,
  airspanHome: 'https://airspan.com/',
};
export default about;
